class SearchTopDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.close();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;

    // Ensure drawer is closed and disable transitions during move
    this.classList.remove("active");
    // Force hide immediately to prevent flash before CSS loads
    this.style.display = "none";
    this.style.visibility = "hidden";
    this.style.opacity = "0";
    this.style.transition = "none";

    // Force reflow to ensure styles are applied
    this.offsetHeight;

    // Move to body
    document.body.appendChild(this);

    // Re-enable transitions after DOM update
    requestAnimationFrame(() => {
      this.style.transition = "";
    });

    // Initialize elements
    this.closeButton = this.querySelector(".search-top-drawer__close");
    this.overlay = this.querySelector(".search-top-drawer__overlay");
    this.input = this.querySelector("#SearchTopDrawerInput");

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    // Beyaz panel dışına (karartılmış alan) tıklanınca kapat
    this.addEventListener("click", (e) => {
      if (!e.target.closest(".search-top-drawer__container")) {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    // Clear inline styles to let CSS take over
    this.style.display = "";
    this.style.visibility = "";
    this.style.opacity = "";

    setTimeout(() => {
      this.classList.add("active");
    }, 10);

    // Focus input
    setTimeout(() => {
      this.input?.focus();
    }, 400);

    // Trap focus if available
    this.addEventListener(
      "transitionend",
      () => {
        if (typeof trapFocus === "function") {
          trapFocus(this, this.input || this.closeButton);
        }
      },
      { once: true }
    );

    document.body.classList.add("o-h");
  }

  close() {
    this.classList.remove("active");

    // Ensure drawer is hidden with inline styles
    this.style.display = "none";
    this.style.visibility = "hidden";
    this.style.opacity = "0";

    if (this.activeElement && typeof removeTrapFocus === "function") {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove("o-h");

    // Clear input and results - handled by predictive-search
    const predictiveSearch = this.querySelector("predictive-search");
    if (predictiveSearch) {
      predictiveSearch.close(true);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (typeof customElements !== "undefined") {
  customElements.define("search-top-drawer", SearchTopDrawer);
}

// Opener
class SearchTopDrawerOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector("button");

    if (!button) return;

    button.addEventListener("click", (e) => {
      e.preventDefault();

      // Wait a bit for the drawer to be moved to body if needed
      setTimeout(() => {
        const drawer = document.querySelector("#SearchTopDrawer");
        if (drawer && typeof drawer.open === "function") {
          drawer.open(button);
        }
      }, 50);
    });
  }
}

if (typeof customElements !== "undefined") {
  customElements.define("search-top-drawer-opener", SearchTopDrawerOpener);
}
